<template>
  <div class="grid content-wrapper" :class="classes">
    <div class="xs-12 content-wrapper__header" :class="{ 'content-wrapper__header--no-margin': !hasHeaderMargin }">
      <slot name="header"></slot>
    </div>
    <div class="xs-12">
      <slot></slot>
    </div>
    <div class="xs-12 content-wrapper__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentWrapper",
  props: {
    classes: {
      type: String,
      default: "",
    },
    hasHeaderMargin: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.content-wrapper {
  &__header {
    @include media("<=s") {
      margin-bottom: $space-x-small;
    }
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: $space-x-large;

    &--no-margin {
      margin-bottom: 0;
    }

    p {
      font-size: $h-font-size-medium;
      margin: $space-x-small 0;

      .dea-links--large {
        line-height: initial;
      }
    }
  }

  &--reduced-margin {
    .content-wrapper__header {
      @include media("<=s") {
        margin-bottom: 0;
      }
      margin-bottom: $space-base;
    }
  }
}
</style>
